module.exports = __webpack_public_path__ + "static/media/11.3ed91427.png";